import React from 'react'

import { Box, Container } from '@material-ui/core'
import { isEmpty } from 'lodash'

import ModuleItem from '../ModuleItem'
import useStyles from './styles'

const ModuleList = ({ modules, portalToken, courseId, history }) => {
  const classes = useStyles()

  if (isEmpty(modules)) return null

  return (
    <Box className={classes.root}>
      <Container maxWidth="lg">
        {modules?.map((module, moduleIndex) => (
          <ModuleItem
            key={module.id}
            module={module}
            moduleIndex={moduleIndex}
            portalToken={portalToken}
            courseId={courseId}
            history={history}
          />
        ))}
      </Container>
    </Box>
  )
}

export default ModuleList
